import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-3 group">
            <span
              className={`w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors ${
                solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/15 text-background-50 backdrop-blur-sm'
              }`}
            >
              <i className="ri-article-line text-lg" />
            </span>
            <h1
              className={`font-heading font-black tracking-tight leading-none transition-colors ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              <span className="text-lg md:text-xl">灵灵黑料</span>
              <span
                className={`hidden sm:inline text-[11px] font-body font-normal tracking-[0.28em] ml-2 align-middle ${
                  solid ? 'text-foreground-500' : 'text-background-50/70'
                }`}
              >
                完整版存档
              </span>
            </h1>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`px-3.5 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors ${
                  solid
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                    : 'text-background-50/85 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#comments"
              className={`hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors ${
                solid
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-950 hover:bg-background-100'
              }`}
            >
              <i className="ri-chat-3-line" />
              参与讨论
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
                solid ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
              }`}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/80 bg-background-50 px-4 py-4">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm font-label text-foreground-800 bg-background-100 hover:bg-background-200 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#comments"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-md text-sm font-label bg-primary-500 text-background-50"
          >
            <i className="ri-chat-3-line" />
            参与讨论
          </a>
        </div>
      )}
    </header>
  );
}